import { TenantModel } from '@/modules/Tenants/domain';
import { CurrentTenantAvatar } from '@/modules/Tenants/pages/TenantProfilePage/components/CurrentTenantAvatar';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface TenantEntryProps {
  tenant: TenantModel;
  className?: string;
  isSelected?: boolean;
  onClick: (tenant: TenantModel) => void;
}

export const TenantEntry = ({
  tenant,
  isSelected,
  className,
  onClick,
}: TenantEntryProps) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="tenant-entry-button"
      role="button"
      tabIndex={0}
      onClick={() => onClick(tenant)}
      onKeyDown={(event) => event.key === 'Enter' && onClick(tenant)}
      className={twMerge(
        'flex h-14 items-center justify-between gap-5 rounded-md border border-transparent bg-white px-2.5 py-1',
        isSelected && 'border-fennelBlue bg-fennelBlue bg-opacity-25',
        !!onClick &&
          'cursor-pointer hover:border hover:border-blueAngel hover:bg-fennelBlue hover:bg-opacity-25',
        className,
      )}
    >
      <div
        className={twMerge(
          `grid items-center gap-5`,
          isSelected ? 'grid-cols-4' : 'grid-cols-3',
          className,
        )}
      >
        <div className="col-span-2 flex items-center gap-2.5">
          <CurrentTenantAvatar size="medium" tenant={tenant} />
          <p className="text-sm font-black">{tenant.name}</p>
        </div>
        <p className="text-sm font-normal">{tenant.userRole}</p>
        {isSelected && (
          <p className={`text-right text-sm italic text-blueNuit`}>
            {t('tenant_selected')}
          </p>
        )}
      </div>
    </div>
  );
};
